import type { AnalyticsEventMap } from "@/utils/analytics";

type CheckoutContext = AnalyticsEventMap["checkout_started"];

const CHECKOUT_CTX_KEY = "ph_checkout_ctx";

/**
 * Remembers what started a checkout. Stripe leaves the SPA and returns via a
 * full page load, so the context is kept in sessionStorage to attribute
 * `checkout_completed` to the paywall/page that triggered `checkout_started`.
 */
export function rememberCheckout(ctx: CheckoutContext): void {
	try {
		sessionStorage.setItem(CHECKOUT_CTX_KEY, JSON.stringify(ctx));
	} catch {
		// Storage can be unavailable (private mode); attribution is best-effort.
	}
}

/** Returns (and clears) the context saved by {@link rememberCheckout}. */
export function recallCheckout(): Partial<CheckoutContext> {
	try {
		const raw = sessionStorage.getItem(CHECKOUT_CTX_KEY);
		sessionStorage.removeItem(CHECKOUT_CTX_KEY);
		return raw ? (JSON.parse(raw) as CheckoutContext) : {};
	} catch {
		return {};
	}
}
